import { useNavigate } from 'react-router-dom'

export default function NotFound() {
  const navigate = useNavigate()
  return (
    <div className="notfound">
      <p className="notfound-code">404</p>
      <h1 className="notfound-title">Not Found</h1>
      <p className="notfound-body">This page doesn't exist, but the food does.</p>
      <button className="btn btn-sand" onClick={() => navigate('/')}>Back to GOAT</button>
    </div>
  )
}
